import gql from 'graphql-tag';

/**
 * Query to fetch a single inspection instance by ID with full detail
 * including responses, observations, and lastPosition.
 */
export const getInspectionInstanceDetailQuery = gql`
  query getInspectionInstanceDetail($id: UUID!, $channelId: UUID!) {
    inspectionInstance(id: $id, channelId: $channelId) {
      id
      schemaVersion
      version
      templateRef {
        templateId
        version
        templateName
      }
      metadata {
        buildingId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        tenantId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        suiteId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        assignedTo
        scheduledFor
        scheduleId
        createdAt
        createdBy
      }
      state {
        status
        startedAt
        completedAt
        completedBy
        closedReason
        lastPosition {
          sectionId
          itemId
        }
        progress {
          totalItems
          completedItems
          requiredItems
          completedRequiredItems
          sectionProgress {
            sectionId
            total
            completed
          }
        }
      }
      responses {
        itemId
        value
        notes
        additionalFields
        isDeficient
        serviceRequestId
        photos {
          id
          localPath
          remoteUrl
          thumbnailUrl
          uploadStatus
          metadata {
            capturedAt
            fileSize
            contentType
            caption
            location {
              latitude
              longitude
              accuracy
            }
            dimensions {
              width
              height
            }
          }
        }
        timestamps {
          createdAt
          updatedAt
          deviceTimestamp
        }
        syncState {
          status
          lastAttempt
          error
          retryCount
        }
      }
      observations {
        id
        sectionId
        description
        addedAt
        suggestAddToTemplate
        response {
          itemId
          value
          notes
          additionalFields
          isDeficient
          serviceRequestId
          photos {
            id
            localPath
            remoteUrl
            thumbnailUrl
            uploadStatus
            metadata {
              capturedAt
              fileSize
              contentType
              caption
              location {
                latitude
                longitude
                accuracy
              }
              dimensions {
                width
                height
              }
            }
          }
          timestamps {
            createdAt
            updatedAt
            deviceTimestamp
          }
          syncState {
            status
            lastAttempt
            error
            retryCount
          }
        }
      }
    }
  }
`;
